import { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, Timestamp, doc, updateDoc, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AddNamaazInput from './AddNamaazInput';

export default function AddNamaaz() {
  const [fajrCount, setFajrCount] = useState(0);
  const [zoharCount, setZoharCount] = useState(0);
  const [asrCount, setAsrCount] = useState(0);
  const [magribCount, setMagribCount] = useState(0);
  const [ishaCount, setIshaCount] = useState(0);
  const [witrCount, setWitrCount] = useState(0);
  const [data, setData] = useState({
      fajr : 0,
      zohar: 0,
      asr: 0,
      magrib: 0,
      isha: 0,
      witr: 0
  });

  const user = useSelector((state) => state.user.userInfo);

  const [isDisable, setDisable] = useState(true);

  const navigate = useNavigate();

  useEffect(()=>{
  
    if(user==null){
      navigate("/login")
    }else{
      initializeRecord()
    }
      
  
    },[])



  const initializeRecord = async () => {
    const querySnapshot = await getDocs(collection(db, 'qazaa_namaaz',user.user.uid+'/db'));
      const dataArr = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
      }));

      let _data = dataArr[0]

      if(_data!=null){
        setData(_data)
        
      }
      setDisable(false)
  }

  const handleSubmit = async (e) => {
    setDisable(true)
    e.preventDefault();
    try{

      var _data = data

      _data.fajr = parseInt(data.fajr)+parseInt(fajrCount)
      _data.zohar = parseInt(data.zohar)+parseInt(zoharCount)
      _data.asr = parseInt(data.asr)+parseInt(asrCount)
      _data.magrib = parseInt(data.magrib)+parseInt(magribCount)
      _data.isha = parseInt(data.isha)+parseInt(ishaCount)
      _data.witr = parseInt(data.witr)+parseInt(witrCount)

      if(data==null || data.id == null){

        const docRef = await addDoc(collection(db, 'qazaa_namaaz',user.user.uid+'/db'), {
          ..._data,
          createdAt: Timestamp.now(),
          updatedAt: Timestamp.now()
        });

        console.log("Document written with ID: ", docRef.id);

      }else{

        const documentRef = doc(db, 'qazaa_namaaz', user.user.uid+'/db/'+data.id);
        try {
          await updateDoc(documentRef, {
            ..._data,
            updatedAt: Timestamp.now()
          });
          console.log('Document updated successfully!');
        } catch (error) {
          console.error('Error updating document:', error);
        }

      }

      setDisable(false)
      
      navigate('/');
    } catch (e) {
      console.error("Error adding document: ", e);
    }
    
  };

  return (
    <div className="p-4">
      <h1>Addd Qazaa Namaaz (Days)</h1>
      
        <AddNamaazInput labelVal="Fajr" inputValueHander={setFajrCount}></AddNamaazInput>
        <br></br>
        <br></br>
        <AddNamaazInput labelVal="Zohar" inputValueHander={setZoharCount}></AddNamaazInput>
        <br></br>
        <br></br>
        <AddNamaazInput labelVal="Asr" inputValueHander={setAsrCount}></AddNamaazInput>
        <br></br>
        <br></br>
        <AddNamaazInput labelVal="Magrib" inputValueHander={setMagribCount}></AddNamaazInput>
        <br></br>
        <br></br>
        <AddNamaazInput labelVal="Isha" inputValueHander={setIshaCount}></AddNamaazInput>
        <br></br>
        <br></br>
        <AddNamaazInput labelVal="Witr" inputValueHander={setWitrCount}></AddNamaazInput>
        <br></br>
        <br></br>
        <button disabled={isDisable} type="button" onClick={handleSubmit} className="bg-blue-500 text-white p-2 ml-2">
          Save
        </button>
 
    </div>
  );
}